import { initializeApp } from 'firebase/app';
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";


const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID 
}
// Initialize Firebase
const app = initializeApp(firebaseConfig);

// App Check désactivé ; pour le réactiver, ajouter :
// import { initializeAppCheck, ReCaptchaV3Provider } from "firebase/app-check";
/*const appCheck = initializeAppCheck(app, {
  provider: new ReCaptchaV3Provider('6Le9T4QpAAAAAKE76j8iqlODaxk2O8xMlkKsT2sv'),
  isTokenAutoRefreshEnabled: true
});*/
// Export firestore database
// It will be imported into your react app whenever it is needed
export const db = getFirestore(app);
export const auth = getAuth(app);
export default app;

